const DEFAULT_PERMISSION = {
  _id: "",
  name: "",
  description: "",
  notes: "",
  tags: [],
};

const DEFAULT_CHANGE_HANDLERS = {
  handleChange: () => {},
};

export const getPermissionFormProps = ({
  formObject = DEFAULT_PERMISSION,
  changeHandlers = DEFAULT_CHANGE_HANDLERS,
}) => {
  const { _id, name, description, notes, tags } = formObject;
  const { handleChange } = changeHandlers;
  return [
    {
      type: "text",
      props: {
        "data-id": _id,
        label: "Name",
        value: name,
        name: "name",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        "data-id": _id,
        label: "Description",
        value: description,
        name: "description",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        "data-id": _id,
        label: "Notes",
        value: notes,
        name: "notes",
        onChange: handleChange,
        className: "w-96",
      },
    },
    {
      type: "text",
      props: {
        "data-id": _id,
        label: "Tags",
        value: tags.join(", "),
        name: "tags",
        onChange: handleChange,
        className: "w-96",
      },
    },
  ];
};
